import React, { createRef, useEffect, useState } from "react";
import { ManageOrders } from "../../Functionalities/Functions";
import {
  formatBillAmount,
  gstLabel,
  isNonZeroAmount,
  isPositiveAmount,
} from "../../Functionalities/billAmounts";
import logoText from "../../Assets/images/logo-text.png";

const OrderExport = () => {
  const ref = createRef();
  // void 0
  const id = window.location.search.split("=")[1];
  // void 0

  const [data, setData] = useState(null);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    let params = "id=" + id;
    let result = ManageOrders("", "get", "", params);
    result
      .then((result) => {
        const order = result && result.data && result.data.results && result.data.results[0];
        if (order) {
          setData({ ...order, branch: order.branch || {} });
        } else {
          setLoadFailed(true);
        }
      })
      .catch(() => setLoadFailed(true));
  };

  if (!data) {
    return (
      <div className="text-center" style={{ padding: 40 }}>
        {loadFailed ? "Order not found" : "Loading order..."}
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        <button
          className="btn btn-primary"
          style={{ margin: 10 }}
          onClick={() => window.history.back()}
          data-dismiss="modal"
        >
          Go back
        </button>
        <button
          className="btn btn-primary"
          style={{ margin: 10 }}
          onClick={() => window.print()}
          data-dismiss="modal"
        >
          Print / Save PDF
        </button>
      </div>

      <div
        style={{
          color: "black",
          display: "flex",
          width: "100%",
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{ padding: 10, marginTop: 5, width: 782, height: 842 }}
          ref={ref}
        >
          <div
            style={{
              marginTop: 50,
              flexDirection: "column",
              textAlign: "center",
              height: 60,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <h2>Foodoor</h2> */}
            <div>
              <img src={logoText} />
            </div>
            <br />
            <b>Order Details</b>
          </div>
          <div
            style={{
              marginTop: 50,
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              height: 150,
            }}
          >
            <div style={{ flex: 1 }}>
              <b style={{ fontWeight: "normal" }}>Order ID: {data.id}</b>
              <br />
              <b style={{ fontWeight: "normal" }}>
                Restaurant: {data.branch.name}
              </b>
              <br />
              <b style={{ fontWeight: "normal" }}>
                Name: {data.user && data.user.first_name}
              </b>
              <br />

              <b style={{ fontWeight: "normal" }}>
                Mobile: {data.user && data.user.details.mobile}
              </b>
              <br />

              <b style={{ fontWeight: "normal" }}>
                Address: {data.address && data.address.address1}
              </b>
            </div>
            <div
              style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}
            >
              <p>
                Date: {data.date && new Date(data.date).toLocaleDateString()} -{" "}
                {data.date && new Date(data.date).toLocaleTimeString()}
              </p>
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <table>
              <tr>
                <th>Sl No</th>
                <th>Product</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Total</th>
              </tr>
              {data.issued_items &&
                data.issued_items.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      {item.item.name} - {item.item_varient.name}
                    </td>
                    <td>{item.rate.toFixed(2)}</td>
                    <td>{item.qty}</td>
                    <td>{item.total.toFixed(2)}</td>
                  </tr>
                ))}
            </table>
          </div>
          <div
            style={{
              marginTop: 50,
              flexDirection: "column",
              height: 200,
              width: "100%",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <b style={{ fontWeight: "normal" }}>
              Product bill : {formatBillAmount(data.amount)}
            </b>
            {isNonZeroAmount(data.item_discount) && (
              <b style={{ fontWeight: "normal" }}>
                Item discount: {formatBillAmount(data.item_discount)}
              </b>
            )}
            {isNonZeroAmount(data.promo_discount) && (
              <b style={{ fontWeight: "normal" }}>
                Promocode discount: {formatBillAmount(data.promo_discount)}
              </b>
            )}
            {isNonZeroAmount(data.wallet_amount) && (
              <b style={{ fontWeight: "normal" }}>
                Wallet amount: {formatBillAmount(data.wallet_amount)}
              </b>
            )}
            {isNonZeroAmount(data.other_charges) && (
              <b style={{ fontWeight: "normal" }}>
                Restaurant charge: {formatBillAmount(data.other_charges)}
              </b>
            )}
            {isNonZeroAmount(data.extra_belly_charges) && (
              <b style={{ fontWeight: "normal" }}>
                Surge: {formatBillAmount(data.extra_belly_charges)}
              </b>
            )}
            {isNonZeroAmount(data.delivery_charge) && (
              <b style={{ fontWeight: "normal" }}>
                Delivery charge : {formatBillAmount(data.delivery_charge)}
              </b>
            )}
            {isPositiveAmount(data.delivery_boy_tip) && (
              <b style={{ fontWeight: "normal" }}>
                Delivery boy tip : {formatBillAmount(data.delivery_boy_tip)}
              </b>
            )}
            {isPositiveAmount(data.branch_gst_charge) && (
              <b style={{ fontWeight: "normal" }}>
                {gstLabel(data.branch_gst_perc)} :{" "}
                {formatBillAmount(data.branch_gst_charge)}
              </b>
            )}
            {data.payment && data.payment.transaction_id != "COD" && (
              <b style={{ fontWeight: "normal" }}>
                Transaction Id: {data.payment.transaction_id}
              </b>
            )}
            <b>Payment method: {data.payment && data.payment.transaction_id}</b>
            <b>Net amount : {formatBillAmount(data.net_amount)}</b>

            {/* Amount : ₹ 1300

Item Discount : ₹ 0

Promocode Discount :₹ 0

Wallet amount : ₹ 0

Delivery charge : ₹ 30

Net Amount : ₹ 1330

Payment
Payment Method : ONLINE

Transaction Amount : ₹ 1330

Transaction Id : pay_GkbNVopepcGPsa */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderExport;
